export default __webpack_public_path__ + "static/media/add_image_bg.53494132.png";